import classNames from 'classnames';
import { Heading } from 'yoso';
import { T } from '~/components/I18n';
import jumbotronStyles from '~/components/Jumbotron/Jumbotron.module.scss';
import { useLand } from '~/components/Land/Land.hooks';
import { landMeta } from '~/components/Land/Land.meta';
import { format } from '~/components/Util/number';
import styles from './LandJumbotron.module.scss';

export type LandJumbotronProps = {
  id: number;
  className?: string;
};

export const LandJumbotron = ({ id, className }: LandJumbotronProps) => {
  const {
    data: { landType, citizenNftLevel },
    isInitialLoading,
  } = useLand(id);

  const { title, image } = landMeta[landType];
  return (
    <div
      className={classNames(
        jumbotronStyles.root,
        styles.root,
        { [styles.skeleton]: isInitialLoading },
        className
      )}>
      <img
        className={classNames(jumbotronStyles.image, styles.image)}
        src={image}
        alt="land"
        width={347}
        height={295}
      />
      <Heading level={4} className={classNames(styles.accent, jumbotronStyles.subTitle)}>
        {title}
      </Heading>
      <Heading level={3} className={jumbotronStyles.title}>
        <T
          name="citizen_land_detail_title"
          options={[
            <span className={styles.name} key={0}>
              {title}
            </span>,
            format(citizenNftLevel, { zeroAsEmpty: true }),
          ]}
        />
      </Heading>
      <p className={classNames(jumbotronStyles.description, 'text-wrap-balance')}>
        <T name="citizen_land_detail_desc" />
      </p>
    </div>
  );
};
